module.exports = __webpack_public_path__ + "img/worker.82bc90f.png";